function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _temp;

var _require = require('@uppy/core'),
    UIPlugin = _require.UIPlugin;

var dataURItoBlob = require('@uppy/utils/lib/dataURItoBlob');

var isObjectURL = require('@uppy/utils/lib/isObjectURL');

var isPreviewSupported = require('@uppy/utils/lib/isPreviewSupported');

var _require2 = require('exifr/dist/mini.umd.js'),
    rotation = _require2.rotation;

var locale = require('./locale');
/**
 * The Thumbnail Generator plugin
 */


module.exports = (_temp = _class = /*#__PURE__*/function (_UIPlugin) {
  _inherits(ThumbnailGenerator, _UIPlugin);

  var _super = _createSuper(ThumbnailGenerator);

  function ThumbnailGenerator(uppy, opts) {
    var _this;

    _classCallCheck(this, ThumbnailGenerator);

    _this = _super.call(this, uppy, opts);

    _this.onFileAdded = function (file) {
      if (!file.preview && file.data && isPreviewSupported(file.type) && !file.isRemote) {
        _this.addToQueue(file.id);
      }
    };

    _this.onCancelRequest = function (file) {
      var index = _this.queue.indexOf(file.id);

      if (index !== -1) {
        _this.queue.splice(index, 1);
      }
    };

    _this.onFileRemoved = function (file) {
      var index = _this.queue.indexOf(file.id);

      if (index !== -1) {
        _this.queue.splice(index, 1);
      } // Clean up object URLs.


      if (file.preview && isObjectURL(file.preview)) {
        URL.revokeObjectURL(file.preview);
      }
    };

    _this.onRestored = function () {
      var restoredFiles = _this.uppy.getFiles().filter(function (file) {
        return file.isRestored;
      });

      restoredFiles.forEach(function (file) {
        // Only add blob URLs; they are likely invalid after being restored.
        if (!file.preview || isObjectURL(file.preview)) {
          _this.addToQueue(file.id);
        }
      });
    };

    _this.onAllFilesRemoved = function () {
      _this.queue = [];
    };

    _this.waitUntilAllProcessed = function (fileIDs) {
      fileIDs.forEach(function (fileID) {
        var file = _this.uppy.getFile(fileID);

        _this.uppy.emit('preprocess-progress', file, {
          mode: 'indeterminate',
          message: _this.i18n('generatingThumbnails')
        });
      });

      var emitPreprocessCompleteForAll = function emitPreprocessCompleteForAll() {
        fileIDs.forEach(function (fileID) {
          var file = _this.uppy.getFile(fileID);

          _this.uppy.emit('preprocess-complete', file);
        });
      };

      return new Promise(function (resolve) {
        if (_this.queueProcessing) {
          _this.uppy.once('thumbnail:all-generated', function () {
            emitPreprocessCompleteForAll();
            resolve();
          });
        } else {
          emitPreprocessCompleteForAll();
          resolve();
        }
      });
    };

    _this.type = 'modifier';
    _this.id = _this.opts.id || 'ThumbnailGenerator';
    _this.title = 'Thumbnail Generator';
    _this.queue = [];
    _this.queueProcessing = false;
    _this.defaultThumbnailDimension = 200;
    _this.thumbnailType = _this.opts.thumbnailType || 'image/jpeg';
    _this.defaultLocale = locale;
    var defaultOptions = {
      thumbnailWidth: null,
      thumbnailHeight: null,
      waitForThumbnailsBeforeUpload: false,
      lazy: false
    };
    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts);

    _this.i18nInit();

    if (_this.opts.lazy && _this.opts.waitForThumbnailsBeforeUpload) {
      throw new Error('ThumbnailGenerator: The `lazy` and `waitForThumbnailsBeforeUpload` options are mutually exclusive. Please ensure at most one of them is set to `true`.');
    }

    return _this;
  }
  /**
   * Create a thumbnail for the given Uppy file object.
   *
   * @param {{data: Blob}} file
   * @param {number} targetWidth
   * @param {number} targetHeight
   * @returns {Promise}
   */


  _createClass(ThumbnailGenerator, [{
    key: "createThumbnail",
    value: function createThumbnail(file, targetWidth, targetHeight) {
      var _this2 = this;

      var originalUrl = URL.createObjectURL(file.data);
      var onload = new Promise(function (resolve, reject) {
        var image = new Image();
        image.src = originalUrl;
        image.addEventListener('load', function () {
          URL.revokeObjectURL(originalUrl);
          resolve(image);
        });
        image.addEventListener('error', function (event) {
          URL.revokeObjectURL(originalUrl);
          reject(event.error || new Error('Could not create thumbnail'));
        });
      });
      var orientationPromise = rotation(file.data).catch(function () {
        return 1;
      });
      return Promise.all([onload, orientationPromise]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            image = _ref2[0],
            orientation = _ref2[1];

        var dimensions = _this2.getProportionalDimensions(image, targetWidth, targetHeight, orientation.deg);

        var rotatedImage = _this2.rotateImage(image, orientation);

        var resizedImage = _this2.resizeImage(rotatedImage, dimensions.width, dimensions.height);

        return _this2.canvasToBlob(resizedImage, _this2.thumbnailType, 80);
      }).then(function (blob) {
        return URL.createObjectURL(blob);
      });
    }
    /**
     * Get the new calculated dimensions for the given image and a target width
     * or height. If both width and height are given, only width is taken into
     * account. If neither width nor height are given, the default dimension
     * is used.
     */

  }, {
    key: "getProportionalDimensions",
    value: function getProportionalDimensions(img, width, height, rotation) {
      var aspect = img.width / img.height;

      if (rotation === 90 || rotation === 270) {
        aspect = img.height / img.width;
      }

      if (width != null) {
        return {
          width: width,
          height: Math.round(width / aspect)
        };
      }

      if (height != null) {
        return {
          width: Math.round(height * aspect),
          height: height
        };
      }

      return {
        width: this.defaultThumbnailDimension,
        height: Math.round(this.defaultThumbnailDimension / aspect)
      };
    }
    /**
     * Make sure the image doesn’t exceed browser/device canvas limits.
     * For ios with 256 RAM and ie
     */

  }, {
    key: "protect",
    value: function protect(image) {
      // https://stackoverflow.com/questions/6081483/maximum-size-of-a-canvas-element
      var ratio = image.width / image.height;
      var maxSquare = 5000000; // ios max canvas square

      var maxSize = 4096; // ie max canvas dimensions

      var maxW = Math.floor(Math.sqrt(maxSquare * ratio));
      var maxH = Math.floor(maxSquare / Math.sqrt(maxSquare * ratio));

      if (maxW > maxSize) {
        maxW = maxSize;
        maxH = Math.round(maxW / ratio);
      }

      if (maxH > maxSize) {
        maxH = maxSize;
        maxW = Math.round(ratio * maxH);
      }

      if (image.width > maxW) {
        var canvas = document.createElement('canvas');
        canvas.width = maxW;
        canvas.height = maxH;
        canvas.getContext('2d').drawImage(image, 0, 0, maxW, maxH);
        image = canvas;
      }

      return image;
    }
    /**
     * Resize an image to the target `width` and `height`.
     *
     * Returns a Canvas with the resized image on it.
     */

  }, {
    key: "resizeImage",
    value: function resizeImage(image, targetWidth, targetHeight) {
      // Resizing in steps refactored to use a solution from
      // https://blog.uploadcare.com/image-resize-in-browsers-is-broken-e38eed08df01
      image = this.protect(image);
      var steps = Math.ceil(Math.log2(image.width / targetWidth));

      if (steps < 1) {
        steps = 1;
      }

      var sW = targetWidth * Math.pow(2, steps - 1);
      var sH = targetHeight * Math.pow(2, steps - 1);
      var x = 2;

      while (steps--) {
        var canvas = document.createElement('canvas');
        canvas.width = sW;
        canvas.height = sH;
        canvas.getContext('2d').drawImage(image, 0, 0, sW, sH);
        image = canvas;
        sW = Math.round(sW / x);
        sH = Math.round(sH / x);
      }

      return image;
    }
  }, {
    key: "rotateImage",
    value: function rotateImage(image, translate) {
      var w = image.width;
      var h = image.height;

      if (translate.deg === 90 || translate.deg === 270) {
        w = image.height;
        h = image.width;
      }

      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      var context = canvas.getContext('2d');
      context.translate(w / 2, h / 2);

      if (translate.canvas) {
        context.rotate(translate.rad);
        context.scale(translate.scaleX, translate.scaleY);
      }

      context.drawImage(image, -image.width / 2, -image.height / 2, image.width, image.height);
      return canvas;
    }
    /**
     * Save a <canvas> element's content to a Blob object.
     *
     * @param {HTMLCanvasElement} canvas
     * @returns {Promise}
     */

  }, {
    key: "canvasToBlob",
    value: function canvasToBlob(canvas, type, quality) {
      try {
        canvas.getContext('2d').getImageData(0, 0, 1, 1);
      } catch (err) {
        if (err.code === 18) {
          return Promise.reject(new Error('cannot read image, probably an svg with external resources'));
        }
      }

      if (canvas.toBlob) {
        return new Promise(function (resolve) {
          canvas.toBlob(resolve, type, quality);
        }).then(function (blob) {
          if (blob === null) {
            throw new Error('cannot read image, probably an svg with external resources');
          }

          return blob;
        });
      }

      return Promise.resolve().then(function () {
        return dataURItoBlob(canvas.toDataURL(type, quality), {});
      }).then(function (blob) {
        if (blob === null) {
          throw new Error('could not extract blob, probably an old browser');
        }

        return blob;
      });
    }
    /**
     * Set the preview URL for a file.
     */

  }, {
    key: "setPreviewURL",
    value: function setPreviewURL(fileID, preview) {
      this.uppy.setFileState(fileID, {
        preview: preview
      });
    }
  }, {
    key: "addToQueue",
    value: function addToQueue(item) {
      this.queue.push(item);

      if (this.queueProcessing === false) {
        this.processQueue();
      }
    }
  }, {
    key: "processQueue",
    value: function processQueue() {
      var _this3 = this;

      this.queueProcessing = true;

      if (this.queue.length > 0) {
        var current = this.uppy.getFile(this.queue.shift());

        if (!current) {
          this.uppy.log('[ThumbnailGenerator] file was removed before a thumbnail could be generated, but not removed from the queue. This is probably a bug', 'error');
          return;
        }

        return this.requestThumbnail(current).catch(function () {}) // eslint-disable-line node/handle-callback-err
        .then(function () {
          return _this3.processQueue();
        });
      }

      this.queueProcessing = false;
      this.uppy.log('[ThumbnailGenerator] Emptied thumbnail queue');
      this.uppy.emit('thumbnail:all-generated');
    }
  }, {
    key: "requestThumbnail",
    value: function requestThumbnail(file) {
      var _this4 = this;

      if (isPreviewSupported(file.type) && !file.isRemote) {
        return this.createThumbnail(file, this.opts.thumbnailWidth, this.opts.thumbnailHeight).then(function (preview) {
          _this4.setPreviewURL(file.id, preview);

          _this4.uppy.log("[ThumbnailGenerator] Generated thumbnail for ".concat(file.id));

          _this4.uppy.emit('thumbnail:generated', _this4.uppy.getFile(file.id), preview);
        }).catch(function (err) {
          _this4.uppy.log("[ThumbnailGenerator] Failed thumbnail for ".concat(file.id, ":"), 'warning');

          _this4.uppy.log(err, 'warning');

          _this4.uppy.emit('thumbnail:error', _this4.uppy.getFile(file.id), err);
        });
      }

      return Promise.resolve();
    }
  }, {
    key: "install",
    value: function install() {
      this.uppy.on('file-removed', this.onFileRemoved);
      this.uppy.on('cancel-all', this.onAllFilesRemoved);

      if (this.opts.lazy) {
        this.uppy.on('thumbnail:request', this.onFileAdded);
        this.uppy.on('thumbnail:cancel', this.onCancelRequest);
      } else {
        this.uppy.on('file-added', this.onFileAdded);
        this.uppy.on('restored', this.onRestored);
      }

      if (this.opts.waitForThumbnailsBeforeUpload) {
        this.uppy.addPreProcessor(this.waitUntilAllProcessed);
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.uppy.off('file-removed', this.onFileRemoved);
      this.uppy.off('cancel-all', this.onAllFilesRemoved);

      if (this.opts.lazy) {
        this.uppy.off('thumbnail:request', this.onFileAdded);
        this.uppy.off('thumbnail:cancel', this.onCancelRequest);
      } else {
        this.uppy.off('file-added', this.onFileAdded);
        this.uppy.off('restored', this.onRestored);
      }

      if (this.opts.waitForThumbnailsBeforeUpload) {
        this.uppy.removePreProcessor(this.waitUntilAllProcessed);
      }
    }
  }]);

  return ThumbnailGenerator;
}(UIPlugin), _class.VERSION = "2.1.1", _temp);